import React from 'react';
import BgMenu from '../../../img/bg_menu.jpg';

const Menu = () => {
    // let toggleBtn = document.querySelector('.toggleBtn');
    // let container = document.querySelector('.container');
    // toggleBtn.onclick = function () {
    //     container.classList.toggle('active');
    // };

    return (
        <div className=''>
            {/* <div className='bg-no-repeat bg-center w-full h-screen py-6 bg-cover text-center md:text-start' style={{
        backgroundImage: 'url(' + BgMenu + ')',
    }}> */}
            <div className='relative'>
                <img className='w-full h-scree' src={BgMenu} alt="" />
            </div>

            {/* <div className='py-10 absolute top-1/4 left-0'>
                <div class="main  relative w-0 h-0 rounded-full delay-300 bg-[#37444b]  flex justify-center items-center active:w-[400px] active:h-[400px] delay-300 active:before:opacity-100 active:before:delay-300 active:before:transition-delay-300">
                    <div class="content min-w-[400px] p-[40px] text-white opacity-0 delay-300 scale-0 active:opacity-100 active:scale-100">
                        <h2>juice</h2>
                        <p>
                            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur
                            saepe dolorem velit autem recusandae molestiae? Veritatis eligendi
                            quisquam quasi repudiandae.
                        </p>
                    </div>
                    <div>
                        <div class="toggleBtn absolute w-[50px] h-[50px] bg-[#683727] rounded-full cursor-pointer flex justify-center items-center p-4 border-2 border-white before:content-['+'] text-2xl text-white font-bold"></div>
                    </div>
                </div>
            </div>
        
            <div className='py-10 absolute top-1/2 left-1/4'>
                <div class="main  relative w-0 h-0 rounded-full delay-300 bg-[#37444b]  flex justify-center items-center active:w-[400px] active:h-[400px] delay-300 active:before:opacity-100 active:before:delay-300 active:before:transition-delay-300">
                    <div class="content min-w-[400px] p-[40px] text-white opacity-0 delay-300 scale-0 active:opacity-100 active:scale-100">
                        <h2>juice</h2>
                        <p>
                            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur
                            saepe dolorem velit autem recusandae molestiae? Veritatis eligendi
                            quisquam quasi repudiandae.
                        </p>
                    </div>
                    <div>
                        <div class="toggleBtn absolute w-[50px] h-[50px] bg-[#9ECDEA] rounded-full cursor-pointer flex justify-center items-center p-4 border-2 border-white before:content-['+'] text-2xl text-white font-bold"></div>
                    </div>
                </div>
            </div>

         
            <div className='py-10 absolute top-1/3 -right-0'>
                <div class="main  relative w-0 h-0 rounded-full delay-300 bg-[#37444b]  flex justify-center items-center active:w-[400px] active:h-[400px] delay-300 active:before:opacity-100 active:before:delay-300 active:before:transition-delay-300">
                    <div class="content min-w-[400px] p-[40px] text-white opacity-0 delay-300 scale-0 active:opacity-100 active:scale-100">
                        <h2>juice</h2>
                        <p>
                            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur
                            saepe dolorem velit autem recusandae molestiae? Veritatis eligendi
                            quisquam quasi repudiandae.
                        </p>
                    </div>
                    <div>
                        <div class="toggleBtn absolute w-[50px] h-[50px] bg-[#FA7152] rounded-full cursor-pointer flex justify-center items-center p-4 border-2 border-white before:content-['+'] text-2xl text-white font-bold"></div>
                    </div>
                </div>
            </div> */}

        </div>
    );
};

export default Menu;